<template>
  <b-nav>
    <b-nav-dropdown ref="dropdownFees" no-caret
      v-if="!this.disablePlatby"
      v-bind:class="{ active: isPoplatkySelected | isUhrazeneSelected }"
    >
      <template #button-content>
        {{ $t('portal.menu.fees').toUpperCase() }}
        <b-icon icon="chevron-down" style="height: 14px; vertical-align: middle; margin-bottom: 1px"></b-icon>
      </template>

      <b-nav-item
        v-if="!this.disablePlatby"
        v-bind:class="{ activeInMenu: isPoplatkySelected }"
        :to="'/' + $customerUuid + '/poplatky'" @click="closeDropDownFees()"
      >
        {{ $t("ekopop.fees-to-pay") }}
      </b-nav-item>

      <b-nav-item
        v-if="!this.disablePlatby"
        v-bind:class="{ activeInMenu: isUhrazeneSelected }"
        :to="'/' + $customerUuid + '/uhrazene'" @click="closeDropDownFees()"
      >
        {{ $t("ekopop.fees-paid") }}
      </b-nav-item>

      <b-nav-item
        v-if="organizace.hasCenik"
        :href="'/' + $customerUuid + '/'" @click.prevent="$backend.getCenik()"
      >
        {{ $t("ekopop.price-list") }}
      </b-nav-item>
    </b-nav-dropdown>

    <b-nav-item
      v-if="hasForms & (!isAuthenticationGranted || !hasLicenceForms || (grupy == null || grupy.length < 4))"
      v-bind:class="{ active: isFormulareSelected }"
      :to="'/' + $customerUuid + '/formulare'"
    >
      {{ $t("ekopop.forms").toUpperCase() }}
    </b-nav-item>

    <b-nav-dropdown ref="dropdownForms" no-caret
      v-if="hasForms & isAuthenticationGranted  & hasLicenceForms & (grupy != null && grupy.length > 3)"
      v-bind:class="{ active: isFormulareSelected }"
    >
      <template #button-content>
        {{ $t('portal.menu.forms').toUpperCase() }}
        <b-icon icon="chevron-down" style="height: 14px; vertical-align: middle; margin-bottom: 1px"></b-icon>
      </template>

      <b-nav-item v-for="grupa in this.grupy"
          v-bind:class="{ activeInMenu: kategorieFormularu != null && grupa.id === kategorieFormularu.id }"
          @click="kategorieClickHandler(grupa)"
      >
            {{ grupa.nazev }}
      </b-nav-item>
    </b-nav-dropdown>

    <b-nav-item
      v-bind:class="{ active: isContactsSelected }"
      :to="'/' + $customerUuid + '/kontakty'"
    >
      {{ $t("portal.contacts").toUpperCase() }}
    </b-nav-item>

    <b-nav-item
      v-if="organizace.odkazObecNazev && organizace.odkazObecUrl"
      :href="organizace.odkazObecUrl"
      @click.prevent="odkazObceVNovemOkne()"
      variant="secondary"
    >
      {{ organizace.odkazObecNazev.toUpperCase() }}
    </b-nav-item>
  </b-nav>
</template>

<script>
import { mapState } from "vuex";
import router from "@/router";

export default {
  data() {
    return {
      isAuthenticationGranted: null,
      hasForms: false,
      hasLicenceForms: false,
      disablePlatby: null,
      odkazy: null,
      grupy: null,
    };
  },
  computed: mapState([
    "organizace",
    "cartCount",
    "isHomeSelected",
    "isPoplatkySelected",
    "isFormulareSelected",
    "isUhrazeneSelected",
    "isCartSelected",
    "isContactsSelected",
    "isConditionsSelected",
    "isProtectionSelected",
    "kategorieFormularu",
  ]),
  mounted() {
    this.$backend.existsMenuForms(response => this.hasForms = this.$utils.isResponseBooleanTrue( response ) );
    this.$backend.isDisablePlatby(response => this.disablePlatby = response.data );
    this.$backend.getAuthenticationStatus(response => {
      this.isAuthenticationGranted = this.$utils.isAuthenticationGranted(response);
      if (this.isAuthenticationGranted){
        this.$backend.checkLicenceFormularu(response => this.hasLicenceForms = this.$utils.isResponseBooleanTrue( response ), null );
        this.getFormulareUzivatele();
      }
      else
        this.isBusy = false;
    });
  },
  methods: {
    closeDropDownFees(){
      this.$refs.dropdownFees.hide();
    },
    closeDropDownForms(){
      this.$refs.dropdownForms.hide();
    },
    odkazObceVNovemOkne() {
      window.open(this.organizace.odkazObecUrl, "_blank");
    },
    getFormulareUzivatele() {
      this.isBusy = true;
      this.$backend.getMenuForms(response => this.assingFormsAndSetBusy(response));
    },
    assingFormsAndSetBusy(response) {
      this.$store.dispatch("setKategorieFormularu", null);

      if (response && response.data && response.status === 200)
        this.odkazy = response.data;
      else
        this.odkazy = [];

      // Skupina položek podle kategorií
      this.grupy = Object.values(
        this.odkazy.reduce((acc, item) => {
          const id = item.idKategorie;
          // Poradi je kladne a unikatni krom null
          const poradi = id != null ? item.poradiKategorie : 2000000000;
          // Nazev je povinny
          const nazev = item.kategorie != null ? item.kategorie : "Bez kategorie";
          const list = acc[id] != null ? acc[id].list : [];
          list.push(item);

          acc[id] = { id: id, poradi: poradi, nazev: nazev, list: list };

          return acc;
        }, {})
      );

      // Seřazení pole grupy
      this.grupy.sort((a, b) => a.poradi == null ? -1 : b.poradi == null ? 1 : a.poradi - b.poradi);
      this.grupy.forEach(grupa => grupa.list.sort((a, b) => this.customSortCompare(a, b, "poradi")));

      this.isBusy = false;
    },
    kategorieClickHandler(entity) {
      this.$store.dispatch("setKategorieFormularu", entity);
      this.closeDropDownForms();

      if (this.$route.name !== "formulare")
        router.push({name: "formulare",});
      else
        this.$emit("kategorie-changed", entity);
    },
    customSortCompare(a, b, field) {
      var result = null;

      // Null hodnoty budou první
      if (a.poradi === null && b.poradi === null) result = a.nazev.localeCompare(b.nazev);
      else if (a.poradi === null) result = -1;
      else if (b.poradi === null) result = 1;
      else if (a.poradi < b.poradi) result = -1;
      else if (a.poradi > b.poradi) result = 1;
      else result = a.nazev.localeCompare(b.nazev);

      return result;
    },
  },
};
</script>
